import styles from './LandingSectionSeparator.module.css';

export function LandingSectionSeparator() {
  return <hr className={styles.root} />;
}
